import React from 'react';
import elegir_img_x from "../images/elegir_x.svg"
import elegir_img_y from "../images/elegir_b-01.svg";
import confirmar_img from "../images/confirmar respuestas_b-01.svg";
import datos_cedula_pass_img from "../images/rut_password.svg";
import seleccionar_distrito_img from "../images/distrito_b-01.svg";
import seleccionar_depto from "../images/departamento_paso1.png";
import {getMessage} from "../util";

const RutSerialPasswordSelect = (props) => {
    const imagenSelect = (district_text) => {
        switch (district_text) {
            case "departamento" :
                return seleccionar_depto;
            default:
                return seleccionar_distrito_img;
        }
    }
    const elegir_img = (props.configuration.square_image ? elegir_img_x : elegir_img_y);
    return(
        <div className="row mb-4">
            <div className="col-12 col-md-6 col-lg-3 text-center">
                    <p className="como-title mt-4">1. {getMessage("paso_seleccionar", props.messages)}</p>
                    <p className="font-italic h5 vp-75">{getMessage("instruccion_seleccionar", props.messages)}</p>
                    <img src={imagenSelect(props.district_text)} className="img-max-300  mt-lg-5 mt-xl-0" alt="Seleccionar"/>
                </div>
            <div className="col-12 col-md-6 col-lg-3 text-center border-left">
                <p className="como-title mt-4">2. {getMessage("paso_elegir", props.messages)}</p>
                <p className="font-italic h5 vp-75">{getMessage("instruccion_elegir", props.messages)}</p>
                <img src={elegir_img} className="img-max-300 mt-lg-5 mt-xl-0" alt="Cómo"/>
            </div>

            <div className="col-12 col-md-6 col-lg-3 text-center border-left">
                <p className="como-title mt-4">3. {getMessage("paso_confirmar", props.messages)}</p>
                <p className="font-italic h5 vp-75">{getMessage("instruccion_confirmar", props.messages)}</p>
                <img src={confirmar_img} className="img-max-300 mt-lg-5 mt-xl-0" alt="Confirmar"/>
            </div>

            <div className="col-12 col-md-6 col-lg-3 text-center border-left">
                <p className="como-title mt-4">4. {getMessage("paso_votar", props.messages)}</p>

                <p className="font-italic h5 vp-75">{getMessage("instruccion_votar_rut_mail", props.messages)}</p>
                <img src={datos_cedula_pass_img} className="img-max-300 mt-lg-5 mt-xl-0" alt="Votar"/>
            </div>




        </div>
    )
}

export default RutSerialPasswordSelect;